export default function addScroll(rect, scroll) {
    return {
        top: rect.top + scroll.y,
        left: rect.left + scroll.x,
        height: rect.height,
        width: rect.width
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-popup-common/dist/es/add-scroll.js
// module id = 1202
// module chunks = 0